import { render } from "./LoginMFAComponent.vue?vue&type=template&id=0731a362&scoped=true"
import script from "./LoginMFAComponent.vue?vue&type=script&lang=js"
export * from "./LoginMFAComponent.vue?vue&type=script&lang=js"

import "./LoginMFAComponent.vue?vue&type=style&index=0&id=0731a362&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0731a362"]])

export default __exports__